import { GRANTED_KINDS, SFU_KINDS, type Kind } from '../protocol';
import { TEACHER_SEAT } from './seats';
import { SCHOOL_GROUP, linkGroup } from './links';
import type { PlaceId } from '../ids';

// 학교 수업 규칙 (사용자가 정했다, docs/architecture.md 9장): 교탁 자리에 앉은 사람이 강사다.
//   강사가 없으면 학교 안 전원이 마이크·카메라·화면 공유를 쓴다(그 전과 같다).
//   강사가 있으면 강사는 셋 다, 강사가 발언권을 준 학생은 마이크·화면 공유, 나머지는 듣기만 한다.
// 서버(SFU 올리기·화면 공유 칸)와 화면(단추·트랙 끄기)이 같은 함수를 쓴다.
export const isTeacherAt = (room: PlaceId | null, seat: number) => TEACHER_SEAT >= 0 && room === 'school' && seat === TEACHER_SEAT;

// 지금 내보낼 수 있는 종류. 학교 밖(테이블·가까운 사람)은 이 규칙이 아니라서 전부 가능하다
export function speakKinds(o: { room: PlaceId | null; seat: number; teacherHere: boolean; granted: boolean }): Kind[] {
  if (linkGroup(o.room, o.seat) !== SCHOOL_GROUP || !o.teacherHere || isTeacherAt(o.room, o.seat)) return SFU_KINDS;
  return o.granted ? GRANTED_KINDS : [];
}
